import React, {Fragment} from 'react';
import {createBackendEditor, referenceActionData} from '../../form/ComponentEditor';
import {postData, fileUpload} from "../../../utils/request";
import {get} from "../../../utils/dotutils";
import Box from '../../layout/Box';
import BoxEditor from "../BoxEditor";
import Button from "../../form/Button";
import StoreOrderBuilderForm from '../forms/StoreOrderBuilderForm';
import StoreOrderBuilderList from '../lists/StoreOrderBuilderList';
import Portal from "../../layout/Portal";
import Modal from "../../layout/Modal";

const isDamaged = (props) => {
    return props.values.xtradata?.preset === "damaged";
}

class StoreOrderBuilderEditor extends React.Component {

    state = {
        refresh: new Date().getTime()
    }

    getValue = (name) => {
        return get(this.props.values, name, undefined);
    }

    getProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        props = {...props, ...this.props[name]};
        return props;
    }

    setFieldValue = (field, value) => {
        if (this.props.setFieldValue) {
            this.props.setFieldValue(field, value);
        }
    }

    onSourceItemUpdate = async (item, oldItem, field) => {
        if (JSON.stringify(item) !== JSON.stringify(oldItem)) {
            if (field !== "qty") {
                item.qty = item.qty || 1;
            }
            if (parseInt(item.qty || 0) > 0) {
                item = JSON.parse(JSON.stringify(item));
                let newItem = JSON.parse(JSON.stringify(this.convert(item)));
                await this.onTransferItems({direction: 'toTarget'}, [newItem]);
                this.picklist && this.picklist.target && this.picklist.target.refreshBackground();
                this.setState({
                    refresh: new Date().getTime()
                });
                return true;
            } else {
                item = JSON.parse(JSON.stringify(item));
                await this.onTransferItems({direction: 'toSource'}, [item]);
                this.picklist && this.picklist.source && this.picklist.source.refreshBackground();
                this.setState({
                    refresh: new Date().getTime()
                });
                return true;
            }
        }
        return item;
    }

    onTargetItemUpdate = async (item, oldItem, field) => {
        const updateItem = JSON.parse(JSON.stringify(item));
        updateItem.StoreOrderBuilder_id = this.props.values[this.props.componentConfig.idfield];
        let actionparams = {
            parentcomponent: this.props.componentConfig.componentname,
            listfield: "items",
            parentid: this.props.values[this.props.componentConfig.idfield],
            action: "componentlist.updateItems",
            items: [updateItem]
        };
        await postData(actionparams);
        this.setState({
            refresh: new Date().getTime()
        });
        return true;
    }

    onTransferItems = async (event, items) => {
        let actionparams = {
            parentcomponent: this.props.componentConfig.componentname,
            listfield: "items",
            parentid: this.props.values[this.props.componentConfig.idfield]
        };

        let action = "addItemsToList"; 

        items = items.map((item) => {
            if (item.StoreOrderBuilder_id) {
                action = "updateItems";
            }
            item.StoreOrderBuilder_id = this.props.values[this.props.componentConfig.idfield];
            return item;
        });

        switch (event.direction) {
            case 'toTarget':
                if (action === "addItemsToList") {
                    items = items.map((item) => ({data: item}));
                }
                actionparams = {
                    ...actionparams,
                    action: "componentlist." + action,
                    items: items
                };
                this.setState({
                    refresh: new Date().getTime()
                });
                return await postData(actionparams);
            case 'toSource':
                actionparams = {
                    ...actionparams,
                    action: "componentlist.removeItemsFromList",
                    items: items
                };
                const ret = await postData(actionparams);
                this.picklist && this.picklist.target && this.picklist.target.refresh();
                this.setState({
                    refresh: new Date().getTime()
                });
                return ret;
        }
    }

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve();
            });
        });
    }

    convert = (row) => {
        row.qty = row.qty || 1;
        return row;
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.list && this.list.list && this.list.list.refresh();
    }

    saveForm = async (event) => {
        await this.props.setFieldValue("saved", 1);
        this.list && this.list.list && this.list.list.refresh();
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
    }

    importFile = async (field, value) => {
        await this.props.processAction(async () => {
            try {
                const response = await fileUpload({action: this.props.componentConfig.componentname + ".importProducts", file: value, data: { id: this.props.values.id }});
                if (response.msg) {
                    this.setState({message: response.msg, messageType: response.success ? "success" : "warning"});
                }
                if (response.success) {
                    this.form && this.form.items && this.form.items.refresh();
                }
                if (response.redirect) {
                    let params = {};
                    parse_str(response.redirect.substr(1), params);
                    this.props.setContent(params.option, params);
                }
            } catch (e) {
                console.error(e);
            }
        });
    }

    createStoreOrder = async () => {
        if (!this.props.values.delivery_note && !this.state.confirmCreateStoreOrder && !isDamaged(this.props)) {
            this.setState({confirmCreateStoreOrder: true});
            return;
        }
        this.setState({confirmCreateStoreOrder: false});
        await this.props.processAction(async () => {
            const response = await postData({
                action: 'StoreOrderBuilder.createStoreOrder',
                data: await referenceActionData(this.props.values, this.props.componentConfig),
                [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield]
            });
            await this.props.pristineForm(false);
            this.props.setContent(response.component, { "id": response.data.id });
        });
    }

    render() {
        const props = {...this.props};
        if (!Array.isArray(props.listFilter)) {
            if (props.listFilter) {
                props.listFilter = [props.listFilter];
            } else {
                props.listFilter = [];
            }
        }
        props.listFilter = [...props.listFilter];
        if (props.in) {
            props.listFilter.push({
                field: "ordertype",
                value: 1
            });
        } else if (props.out || isDamaged(props)) {
            props.listFilter.push({
                field: "ordertype",
                value: 0
            });
        }
        return (
            <Fragment>
                <Box 
                    {...props}
                    collapsed={props.collapsed || false}
                    theme="default"
                    header={!isDamaged(props) ? "Raktári rendelés feladások" : "Selejt raktári rendelés feladások"}
                    footer={[
                        <Button
                            key="0"
                            disabled={props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <StoreOrderBuilderList ref={(el) => this.list = el} {...props} loadForm={this.loadForm} />
                </Box>
                {props.values[props.componentConfig.idfield] && <BoxEditor
                    {...props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={!isDamaged(props) ? "Rakári rendelés feladása" : "Selejt raktári rendelés feladása"}
                    footer={[
                        <Fragment
                            key="4"
                        >
                            <Portal>
                                <Modal
                                    state={this.state.confirmCreateStoreOrder}
                                    header="Biztos?"
                                    buttons={[
                                        {
                                            text: "Mégse",
                                            props: {color: "default", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                                            onClose: true,
                                            onClick: async () => {
                                                try {
                                                    this.setState({confirmCreateStoreOrder: false});
                                                } catch (e) {

                                                }
                                            }
                                        },
                                        {
                                            text: "Igen",
                                            props: {color: "primary", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                                            onClick: async () => {
                                                await this.createStoreOrder();
                                            }
                                        }
                                    ]}
                                >
                                    Nincs feltöltve szállítólevél, biztos így kerüljön rögzítésre?
                                </Modal>
                            </Portal>
                            <Button
                                disabled={props.isLoading || !props.values.id}
                                color="primary"
                                className="pull-right"
                                onClick={async (e) => {
                                    this.createStoreOrder();
                                }}
                            >
                                Feladás
                            </Button>
                        </Fragment>,
                        <Button
                            key="0"
                            disabled={!props.dirty || props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>,
                        <Button
                            key="1"
                            disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                            color="danger"
                            className="pull-left"
                            onClick={this.props.deleteForm}
                        >
                            Törlés
                        </Button>
                    ]}>
                    <StoreOrderBuilderForm ref={(el) => this.form = el} {...props} importFile={this.importFile} isDamaged={isDamaged} />
                </BoxEditor>}
            </Fragment>
        );
    }

}

const editor = (preset) => createBackendEditor({
    componentName: "StoreOrderBuilder",
    WrappedComponent: StoreOrderBuilderEditor,
    editor: "StoreOrderBuilder",
    dirtyFlag: (values) => {
        return !parseInt(values.saved) && values.id;
    },
    props: {
        componentActions: async (action, data, params, componentConfig) => {
            data = await referenceActionData(data, componentConfig);
            data.xtradata = {...(data.xtradata || {}), preset};
            return {action,data,params};
        }
    }
});

const StoreOrderBuilder = editor();
const StoreOrderBuilderDamaged = editor("damaged");

export default StoreOrderBuilder;

export const StoreOrderBuilderInEditor = (props) => {
    return <StoreOrderBuilder {...props} editorContext="StoreOrderBuilderIn" in={true} pristineValues={{ordertype: 1}} />;
}

export const StoreOrderBuilderOutEditor = (props) => {
    return <StoreOrderBuilder {...props} editorContext="StoreOrderBuilderOut" out={true} pristineValues={{ordertype: 0}} />;
}

export const StoreOrderBuilderDamagedEditor = (props) => {
    return <StoreOrderBuilderDamaged {...props} editorContext="StoreOrderBuilderDamaged" pristineValues={{ordertype: 0}} />;
}
